import axios from "axios";

export const backoffice = axios.create({
  baseURL: "https://backoffice.nadu.xyz/api",
  // baseURL: "http://localhost:1338/api",
  withCredentials: false,
  headers: {
    Authorization:
      "Bearer 099d3fb303b5df18ad139ec06acf53114b17b891eb6d8ac926c91529374a927b850c60286502aa0f80877347754c8c6e94601c97091d7c7ef00371a1d7097c7b92b7f489428c4181cb7aa8f20e402d11cbdaa982fcd2ca7707b1da27d5428d1a092e185283b80b9c2bf939b221ad613bcbf5411b99d6484547f84eb6ce016426",
  },
});



// WEBPACK FOOTER //
// ./src/utils/axios/backoffice.js